import { useEffect } from "react";

/**
 * JsonLd — injects a <script type="application/ld+json"> block into <head>
 * for the current page, and removes it on unmount / when data changes.
 * Pass a single schema object or an array of schema objects.
 *
 * Usage:
 *   <JsonLd data={{
 *     "@context": "https://schema.org",
 *     "@type": "Service",
 *     "name": "Transporte al aeropuerto y tours",
 *     "provider": { "@id": "https://www.transporteenvanesybuses.com/#organization" },
 *     "areaServed": "Bogotá",
 *     "description": "..."
 *   }} id="service-jsonld" />
 */
export default function JsonLd({ data, id }) {
  useEffect(() => {
    if (!data) return;
    const scriptId = id || "page-jsonld";
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const existing = document.getElementById(scriptId);
      if (existing) existing.remove();
    };
  }, [data, id]);

  return null;
}

/** Helper to build a BreadcrumbList schema from an array of {name, url} */
export function buildBreadcrumbs(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((it, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": it.name,
      "item": it.url,
    })),
  };
}
